import React from 'react';

import { Redirect, Route } from 'react-router';

import { useAuth } from '../../../context/AuthContext';
import { PrivateRouteProps } from './types';

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, children, ...rest }) => {
  const { authStatus } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) =>
        authStatus && Component ? <Component {...props} /> : <Redirect to="/auth" />
      }
    >
      {children}
    </Route>
  );
};

export default PrivateRoute;
